var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"workarea"},[_c('div',{staticClass:"ui-wood-block-chiseling",class:{'animate': _vm.isAnimate }}),_c('div',{staticClass:"tool tool--small-chisel",class:{'animate': _vm.isAnimate }})])])}
var staticRenderFns = []

export { render, staticRenderFns }